import { BasePayloadMapper } from '@ps/utils';
import { TemplateDetail } from '@ps/survey-utils';

import { TemplateSurveyPayloadDto } from '../dtos/survey.dto';
import { SURVEY_CATEGORY_CODE } from '../../utils';

/** Matches legacy's `source` on the create-survey body for platform-originated surveys. */
const PLATFORM_SOURCE = 'platform';

export interface TemplateSurveyPayloadInput {
  detail: TemplateDetail;
  userId: number;
  companyId: number;
}

export class TemplateSurveyPayloadMapper extends BasePayloadMapper<
  TemplateSurveyPayloadInput,
  TemplateSurveyPayloadDto
> {
  public toPayload({
    detail,
    userId,
    companyId,
  }: TemplateSurveyPayloadInput): TemplateSurveyPayloadDto {
    const { metadata } = detail;

    return {
      survey_title: metadata.surveyTitle,
      click_balancing: metadata.clickBalancing ? 1 : 0,
      estimated_clicks: metadata.estimatedClicks,
      survey_category_code: SURVEY_CATEGORY_CODE,
      survey_localization: metadata.surveyLocalization,
      completes_required: metadata.completes ?? 0,
      expected_ir: metadata.incidence,
      expected_loi: metadata.loi,
      field_time: metadata.fieldTime,
      source: PLATFORM_SOURCE,
      buyer_user_id: userId,
      buyer_company: companyId,
      template_id: detail.templateId,
    };
  }
}
